module.exports = __webpack_public_path__ + "static/media/study.96dcccde.svg";